import L from "leaflet";

export const createEditablePolygon = (
  coords: L.LatLngExpression[] | L.LatLngExpression[][],
  ref: L.FeatureGroup<any> | null
) => {
  const polygon = L.polygon(coords, {
    color: "#27272A",
    fillColor: "#27272A",
    fillOpacity: 0.2,
    opacity: 0.5,
  });

  ref?.addLayer(polygon);

  return polygon;
};
